import { GenerateProgramChangesExportStepCtrl } from './generate-program-changes-export.controller';

export const GenerateProgramChangesExportStepComponent = {
  controller: GenerateProgramChangesExportStepCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
    currentCourseDiffs: '<',
  },
  template: require('./generate-program-changes-export.html'),
};
